export const GA_FOLLOW_ORGANIZER_ACTION = 'FollowOrganizer';

/* GDPR */
export const GA_SHOW_GDPR_MODAL = 'GDPRModalShown';
export const GA_GDPR_ACCEPT_ACTION = 'FollowOrganizerGDPRAccept';
export const GA_GDPR_REJECT_ACTION = 'FollowOrganizerGDPRReject';

export const GA_GDPR_COLLECTION_ACCEPT_ACTION = 'FollowCollectionGDPRAccept';
export const GA_GDPR_COLLECTION_REJECT_ACTION = 'FollowCollectionGDPRReject';
